import { Paper, Table, TableCell, TableRow } from "@mui/material";
import { FC } from "react";
import './styles.css';

interface CondicoesPagamentoProps {
    dados: any;
    dadosParcela: any[];
}

const CondicoesPagamento: FC<CondicoesPagamentoProps> = ({
    dados,
    dadosParcela,
}) => {

    const parcelasCartao: any[] = []
    const parcelas = dadosParcela || []


    parcelas.forEach((parcela: any) => {
        if (dados?.projeto?.valor_servico_pis_cofins !== 0 || dados?.projeto?.valor_servico !== 0) {
            if (parcela?.servicos_pedido?.length > 0 &&
                parcela?.servicos_pedido?.find((sp: any) => sp.servico_pedido !== 'sem_servico') &&
                parcelasCartao.find(p => p === parcela.parcelas) === undefined) {
                parcelasCartao.push(parcela.parcelas);
            }
        } else {
            if (parcela?.servicos_pedido?.length > 0 &&
                parcela?.servicos_pedido.find((sp: any) => sp.servico_pedido === 'sem_servico') &&
                parcelasCartao?.find(p => p === parcela.parcelas) === undefined) {
                parcelasCartao.push(parcela.parcelas);
            }
        }
    })

    const primeiraParcelaComJuros = parcelasCartao?.[0] || '';
    const ultimaParcelaComJuros = parcelasCartao?.[parcelasCartao.length - 1] || '';

    return <>
        <div className="title">Condições de pagamento</div>

        <div className="default-text-list"><span>O processo do pagamento é realizado diretamente com a Intelbras. Você receberá um link por
            e-mail, para criar seu login e senha de acesso à Plataforma, onde também poderá acompanhar
            o status do seu projeto.</span></div>

        <Table component={Paper} size="small" className="table table-codicoes-pagamento" style={{ margin: "10pt 25pt 15pt 25pt", width: "91%" }}>
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    Boleto
                </TableCell>
                <TableCell className="tableColEquipamento">
                    À vista
                </TableCell>
            </TableRow>
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    PIX
                </TableCell>
                <TableCell className="tableColEquipamentoOdd">
                    À vista
                </TableCell>
            </TableRow>
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    Múltiplas formas de pagamento
                </TableCell>
                <TableCell className="tableColEquipamento" style={{color: "#494848"}}>
                    <div>PIX e cartão de crédito</div>
                    <div>PIX e financiamento externo</div>
                    <div>PIX e financiamento via Plataforma</div>
                    <div>Boleto e cartão de crédito</div>
                    <div>Boleto e financiamento externo</div>
                    <div>Boleto e financiamento via Plataforma</div>
                    <div>Cartão de crédito e financiamento externo</div>
                    <div>Cartão de crédito e financiamento via Plataforma</div>
                </TableCell>
            </TableRow>
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    Financiamento bancário*
                </TableCell>
                <TableCell className="tableColEquipamentoOdd" style={{color: "#494848"}}>
                    <div>Financiamento direto (via Plataforma)</div>
                    <div>Financiamento indireto (externo)</div>
                </TableCell>
            </TableRow>
            <TableRow >
                <TableCell className="tableColEquipamentoHead tableColCodicaoPagamentoHead">
                    Cartão de crédito
                </TableCell>
                <TableCell className="tableColEquipamento" style={{color: "#494848"}}>
                    {primeiraParcelaComJuros > 1 ? (
                        <div>em até <strong>{primeiraParcelaComJuros - 1}x</strong> sem juros (Em até dois cartões)</div> 
                    ) : null}
                    {ultimaParcelaComJuros ? (
                        <div>de <strong>{primeiraParcelaComJuros}x</strong> até <strong>{ultimaParcelaComJuros}x</strong> com juros (Em até dois cartões)</div>
                    ) : null}
                </TableCell>
            </TableRow>

        </Table>
        
        <div style={{marginTop: "40pt"}}></div>
        <div className="default-text-list"><span>Nos casos acima, estão disponíveis as seguintes formas de pagamento:</span></div>
        <div className="container-prazo-entrega">
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Boleto à vista + 1 (um) cartão de crédito;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">2 (dois) cartões de crédito;</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">Boleto + Financiamento direto (via Plataforma);</div>
            </div>
            <div className="item-prazo-entrega">
                <div className="marcador-prazo-entrega" >»</div>
                <div className="texto-prazo-entrega">1 (um) cartão de crédito + Financiamento direto (via Plataforma);</div>
            </div>
        </div>

        <div style={{ marginTop: "20pt" }}></div>
        <div className="default-text-list default-small-text"><span>*Sujeito à análise de crédito da instituição financeira.</span></div>
    </>
}

export default CondicoesPagamento;